import classNames from 'classnames'
import { RoutePaths } from 'src/routes/routePaths'
import { OnboardingStep } from '../../OnboardingStep/OnboardingStep'
import { getStepStatus } from '../utils'
import { useHistory } from 'react-router-dom'
import { userOnboardingModalAtom } from 'src/atoms/modals/userOnboardingModal.atom'
import { useSetAtom } from 'jotai'
import { OnboardingListItem } from '../OnboardingListItem'

import './FavoriteChefStep.scss'

interface FavoriteChefStepProps {
  completed: boolean
  enabled: boolean
}

export function FavoriteChefStep({
  completed,
  enabled
}: Readonly<FavoriteChefStepProps>) {
  const history = useHistory()
  const setUserOnboardingModal = useSetAtom(userOnboardingModalAtom)

  const handleSetPreferences = () => {
    setUserOnboardingModal({ isOpen: false })
    history.push(RoutePaths.MEAL_PREFERENCES)
  }

  return (
    <OnboardingStep
      title="Build your Taste Profile"
      description="Tell us about your preferences and discover chefs creating dishes you’ll crave."
      status={getStepStatus(completed, enabled)}
      icon="filters"
      action={{
        label: 'Create profile',
        onClick: handleSetPreferences,
        icon: true
      }}>
      <div className="favorite-chef-step__description">
        <h3>Be sure to share:</h3>
        <ul
          className={classNames('favorite-chef-step__list', {
            'favorite-chef-step__list--completed': completed
          })}>
          <OnboardingListItem completed={completed}>
            Who's in your household.
          </OnboardingListItem>
          <OnboardingListItem completed={completed}>
            Your meal preferences for automatic orders.
          </OnboardingListItem>
          <OnboardingListItem completed={completed}>
            Any dietary needs we should keep in mind.
          </OnboardingListItem>
        </ul>
      </div>
    </OnboardingStep>
  )
}
